import { render, staticRenderFns } from "./issue_row.vue?vue&type=template&id=b7a3aace&scoped=true&lang=pug"
import script from "./issue_row.vue?vue&type=script&lang=js"
export * from "./issue_row.vue?vue&type=script&lang=js"
import style0 from "./issue_row.vue?vue&type=style&index=0&id=b7a3aace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a3aace",
  null
  
)

export default component.exports